import React, { useState, useContext } from "react";
import { AppContext } from "../../AppContext";

import { isClient } from "../../common/checkClient";

import DatePicker from "react-datepicker";
import { fetchCall } from "../../common/FetchHelpers";
import UserAccountBeneficiary from "./UserAccountBeneficiary";
import UserSelectBox from "../common/controls/UserSelectBox";


const UserAccountCreateFormComp = (props) => {
  const [appContext, setAppContext] = useContext(AppContext);
  
  const validationUrl = "api/user-account/validate";

  const isStewardBlackdiamond = isClient('stewardblackdiamond');

  const [validation, setValidation] = useState({
    valid: true,
    message:'Form data are valid',
    accountNumber: true,
    accountName: true,
    brokerDealerId: true,
    otherBrokerDealer:true,
    accountRelation:true,
    otherRelation:true,
    accountRegistration:true,
    otherRegistration:true,
    accountType:true,
    accountOpenDate:true
  });

  const validate = (callBack) => {
    const valid =
      props.data.accountNumber
      && props.data.accountName
      && props.data.brokerDealerId
      && (props.data.brokerDealerId !== 'Other' || props.data.otherBrokerDealer)
      && props.data.accountRelation
      && (props.data.accountRelation !== 'Other' || props.data.otherRelation)
      && props.data.accountRegistration
      && (props.data.accountRegistration !== 'Other' || props.data.otherRegistration)
      && props.data.accountType
      && props.data.accountOpenDate
      ? true
      : false;
   
    if(valid){// validated client side now check serverside

        const reqOptions = {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({id:props.data.id,accountNumber:props.data.accountNumber,submittedFor:props.data.submittedFor}),
        };

        fetchCall(validationUrl, reqOptions)
        .then((result)=>{
            console.log(result);
            
            callBack(result.valid,result.message);

        })
        .catch((err)=>{
            callBack(false,"Server error, Please contact support");
        });
    }else{
      callBack(valid,'Please Enter Required Fields');
    }
  };




  const handleSaveClick = (e) => {

    validate(completeValidation);

  };


  const completeValidation = (valid,message)=>{
    setValidation({
      ...validation,
      valid, message,
      accountNumber: props.data.accountNumber ? true : false,
      accountName: props.data.accountName ? true : false,
      brokerDealerId: props.data.brokerDealerId ? true : false,
      otherBrokerDealer: (props.data.brokerDealerId !== 'Other' || props.data.otherBrokerDealer) ? true : false,
      accountRelation: props.data.accountRelation ? true : false,
      otherRelation: (props.data.accountRelation !== 'Other' || props.data.otherRelation) ? true : false,
      accountRegistration: props.data.accountRegistration ? true : false,
      otherRegistration: (props.data.accountRegistration !== 'Other' || props.data.otherRegistration) ? true : false,
      accountType: props.data.accountType ? true : false,
      accountOpenDate: props.data.accountOpenDate ? true : false,
    });

    if(valid){
      props.handleSaveClick();
    }

  }
  
    // useEffect(() => {
    //     console.log(validation);
        
    //   }, [validation]);


  return (
    <div className="form">
      <div className="form-header">
        <div className="form-header-label">Add a New Brokerage & Investment Account</div>
        {localStorage.getItem("ENABLE_ACCOUNT_APPROVAL")==='true' && <div className="red">The reporting and approval of all newly opened accounts are required by the Compliance Department</div>}
      </div>

      <div className="form-body">
        <div className="form-items">
          <div className="form-row">
            <div className="form-item">
              <div className="form-desc">
                Enter your account details. Certain fields with a (*) are required. If your financial institution is not on the drop-down list, please contact the Compliance Department.
              </div>
            </div>
          </div>



          <div className="form-columns">

            <div className="form-column">
                
              <div className="form-item">
                <label className={`form-item-label required ${validation.accountNumber ? "" : "warning"}`} htmlFor="accountNumber">Account Number :</label>
                <input className="form-item-value" type="text" id="accountNumber" name="accountNumber" maxLength="255" value={props.data.accountNumber} onChange={props.handleChange}/>
              </div>
              
              <div className="form-item">
                <label className={`form-item-label required ${validation.accountName ? "" : "warning"}`} htmlFor="accountName">Account Name :</label>
                <input className="form-item-value" type="text" id="accountName" name="accountName" maxLength="255" value={props.data.accountName} onChange={props.handleChange}/>
              </div>


              <div className="form-item">
                  <label className={"form-item-label"} >Beneficiaries :</label>
                  <UserAccountBeneficiary beneficiaries={props.data.beneficiaries} onAdd={props.beneficiaryAdd} onRemove={props.beneficiaryRemove} onChange={props.beneficiaryChange}/>
              </div>

              <div className={`form-item ${props.data.accountRelation==='Other'?'mb-0-important':''}`}>
                <label className={`form-item-label required ${validation.accountRelation ? "" : "warning"}`} htmlFor="accountRelation">Account Relationship:</label>
                <select className="form-item-value" name="accountRelation" value={props.data.accountRelation} onChange={props.handleChange}>
                  <option key="" value="">(Select One)</option>
                  <option key="Self" value="Self">Self</option>
                  <option key="Spouse" value="Spouse">Spouse</option>
                  <option key="Joint" value="Joint">Joint</option>
                  <option key="Non-Spouse" value="Non-Spouse">Non-Spouse</option>
                  <option key="Partner" value="Partner">Partner</option>
                  <option key="Child" value="Child">Child</option>
                  <option key="Guardian" value="Guardian">Guardian</option>
                  <option key="Trust" value="Trust">Trust</option>
                  {isStewardBlackdiamond &&
                    <option key="Personal Fiduciary/Authorized Agent" value="Personal Fiduciary/Authorized Agent">Personal Fiduciary/Authorized Agent</option>
                  }
                  <option key="Other" value="Other">Other(Please Describe)</option>
                </select>
              </div>
              {props.data.accountRelation ==='Other' &&
                <div className="form-item">
                    <label className={`form-item-label required ${validation.otherRelation ? "" : "warning"}`} >Other Relationship :</label>
                    <input className="form-item-value" type="text" id="otherRelation" name="otherRelation" maxLength="255" value={props.data.otherRelation} onChange={props.handleChange}/>
                </div>
              }

              <div className={`form-item ${props.data.accountRegistration==='Other'?'mb-0-important':''}`}>
                <label className={`form-item-label required ${validation.accountRegistration ? "" : "warning"}`} htmlFor="accountRegistration">Account Registration:</label>
                <select className="form-item-value" name="accountRegistration" value={props.data.accountRegistration} onChange={props.handleChange}>
                  <option key="" value="">(Select One)</option>
                  <option key="Individual" value="Individual">Individual</option>
                  <option key="Joint - Rights of Survivorship" value="Joint - Rights of Survivorship">Joint - Rights of Survivorship</option>
                  <option key="Investment Club" value="Investment Club">Investment Club</option>
                  <option key="Custodial Account (UTGMA/UTMA)" value="Custodial Account (UTGMA/UTMA)">Custodial Account (UTGMA/UTMA)</option>
                  <option key="Retirement Account (401K, IRA, 403b)" value="Retirement Account (401K, IRA, 403b)">Retirement Account (401K, IRA, 403b)</option>
                  {isStewardBlackdiamond &&
                  <>
                    <option key="Joint" value="Joint">Joint</option>
                    <option key="Individual Directed Retirement Plan (IRA, Roth IRA, etc.)" value="Individual Directed Retirement Plan (IRA, Roth IRA, etc.)">Individual Directed Retirement Plan (IRA, Roth IRA, etc.)</option>
                    <option key="Employer Directed Retirement Plan (401K,403B, etc)" value="Employer Directed Retirement Plan (401K,403B, etc)">Employer Directed Retirement Plan (401K,403B, etc)</option>
                    <option key="Estate" value="Estate">Estate</option>
                    <option key="Trust" value="Trust">Trust</option>
                    <option key="529" value="529">529</option>
                    <option key="Business Entity (LP, LLC, SP, etc.)" value="Business Entity (LP, LLC, SP, etc.)">Business Entity (LP, LLC, SP, etc.)</option>
                  </>
                  }
                  <option key="Other" value="Other">Other(Please Describe)</option>
                </select>
              </div>
              {props.data.accountRegistration === 'Other' &&
                <div className="form-item">
                    <label className={`form-item-label required ${validation.otherRegistration ? "" : "warning"}`} >Other Registration :</label>
                    <input className="form-item-value" type="text" id="otherRegistration" name="otherRegistration" maxLength="255" value={props.data.otherRegistration} onChange={props.handleChange}/>
                </div>
              }

              <div className="form-item">
                <label className={`form-item-label required ${validation.accountType ? "" : "warning"}`} htmlFor="accountType">Account Type:</label>
                <select className="form-item-value" name="accountType" value={props.data.accountType} onChange={props.handleChange}>
                  <option key="" value="">(Select One)</option>
                  <option key="Cash" value="Cash">Cash</option>
                  <option key="Margin" value="Margin">Margin</option>
                  <option key="Crypto related" value="Crypto related">Crypto related</option>
                </select>
              </div>

              <div className="form-item">
                <label className={`form-item-label required ${validation.accountOpenDate ? "" : "warning"}`} htmlFor="accountOpenDate">Open Date :</label>
                <div className="form-item-value">
                  <DatePicker selected={props.data.accountOpenDate} onChange={props.handleDateChange}/>
                </div>
              </div>
            </div>

            <div className="form-column">
              <div className="form-item">
                <label className={`form-item-label required ${validation.brokerDealerId ? "" : "warning"}`} htmlFor="brokerDealerId">Your Financial Institution:</label>
                <select className="form-item-value" name="brokerDealerId" value={props.data.brokerDealerId} onChange={props.handleChange}>
                  <option key="" value="">(Select One)</option>
                  {props.metadata.brokerDealer &&
                    props.metadata.brokerDealer.map((rr) => (
                      <option key={rr.id} value={rr.id}>
                        {rr.name}
                      </option>
                    ))}
                    
                    {localStorage.getItem("ALLOW_UNKNOWN_BROKERDEALER")==='true' && <option key='Other' value='Other'>Other (Please specify)</option>}    

                </select>
              </div>
              {props.data.brokerDealerId === 'Other' &&
              <>
                  <div className="form-item">
                      <label className={`form-item-label required ${validation.otherBrokerDealer ? "" : "warning"}`}>Name of the Broker-Dealer Or Investment Advisor :</label>
                      <input className="form-item-value" type="text" id="otherBrokerDealer" name="otherBrokerDealer" maxLength="255" value={props.data.otherBrokerDealer} onChange={props.handleChange}/>
                  </div>

                  <div className="form-item">
                      <label className="form-item-label">Address :</label>
                      <input className="form-item-value" type="text" id="otherBrokerDealerAddress" name="otherBrokerDealerAddress" maxLength="255" value={props.data.otherBrokerDealerAddress} onChange={props.handleChange}/>
                  </div>

                  <div className="form-item">
                      <label className="form-item-label">Contact Information :</label>
                      <textarea rows="3" className="form-item-value" id="otherBrokerDealerContact" name="otherBrokerDealerContact" maxLength="1024" value={props.data.otherBrokerDealerContact} onChange={props.handleChange}/>
                  </div>
              </>
              }
              <div className="form-item">
                    <label className="form-item-label">Is this account professionally managed and does not allow for Self-directed transactions?</label>
                    <div className="form-item-value label-group">
                      <label>
                        <input type="radio" className="form-check-input" name="professionallyManaged" checked={props.data.professionallyManaged === 'N'} onChange={props.handleChange} value="N" />No
                      </label>
                      <label>
                        <input type="radio" className="form-check-input" name="professionallyManaged" checked={props.data.professionallyManaged === 'Y'} onChange={props.handleChange} value="Y" />Yes
                      </label>
                    </div>
              </div>

              <div className="form-item">
                  <label className="form-item-label" htmlFor="attachment">Attachment Document :</label>
                  <div className="form-item-value">
                    <div className="placeholder">
                        <input type="file" name="attachment" id="attachment" onChange={props.handleChange}/>
                    </div>
                    <div>
                        <label className='form-item-label'>Include Account Documents</label>
                    </div>
                  </div>
              </div>

              { appContext.user.submitOnBehalf &&
                <UserSelectBox label='Submit On Behalf of (Optional) : ' styleClass='mt-3rem' onSelected={props.handleChange} name='submittedFor' value={ ()=> {return props.data.submittedFor?{value:props.data.submittedFor,label:props.data.submittedForLabel}:null}}/>
              }

            </div>

          </div>



        
        
        </div>
      </div>

      <div className="form-footer">
        {validation.valid ? (<div className="form-status"></div>) : (<div className="form-status error">{validation.message}</div>)}
        <div className="btn-group">
          <button id="btnGetProductList" type="button" className="btn btn-primary-outline" onClick={props.handleCancel}>Cancel</button>
          <button id="btnLoadProductDetail" type="button" className="btn btn-primary" onClick={handleSaveClick}>Save {localStorage.getItem("ENABLE_ACCOUNT_APPROVAL")==='true' && "and Review"}</button>
        </div>
      </div>
    </div>
  );
};

export default UserAccountCreateFormComp;
